import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import store from '../../store';
import {
    required
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "gradingCreate",
    components: {
        MainLayout,
        Select2Multiple,
        flatPickr,
        Loading
    },

    data() {
        return {
            isLoading: false,
            classData: {},
            className: '',
            classArr: [],
            examName:'',
            examNameArr: [],
            academic_year: '',
            academicYear: '',
            class_id: '',
            exam_id: '',
            academicYearArr: null,
            submitted: false,
            noExamMsg: '',
            invalidFile: false,
            invalidFileSize:false,
            file_name: '',
            autoGrading:false,
            disabledTemplateBtn: true,
            disableInputFields: false,
            disableImportBtn: false,
        };
    },

    validations: {
        class_id: {
            required
        },
        academic_year: {
            required
        },
        exam_id: {
            required
        },
        file_name: {
            required
        },
    },

    methods: {
        getCurrentPeriodList() {
            axios.get('/period/getCurrentPeriodList', {
                params: {
                    campus_id: store.state.user.campus_id,
                }
            })
            .then(res => {
                let $defaultSelectOption = [{
                    'id': 0,
                    'text': 'Select Academic Year'
                }];
                this.academicYearArr = $defaultSelectOption.concat(res.data);
                this.isLoading = false;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            });
        },

        changeEvent(val, fieldName) {
            this.submitted = false;
            this.$set(this, fieldName, val);
            if (fieldName == "academic_year") {
                this.isLoading = true;
                this.classArr = [];
                this.examNameArr = [];
                this.class_id = 0;
                this.exam_id = '';
                this.getClass(val);
            }
            if (fieldName == "class_id") {
                this.isLoading = true;
                this.class_id = val;
                this.examNameArr = [];
                this.exam_id = '';
                if (val && val > 0) {
                    const selectedClass = this.classArr.find(classInfo => classInfo.id === Number(val));
                    this.className = selectedClass.text.normalize('NFC')
                        .replace(/[^\p{L}\p{N}\p{M}\s]/gu, '_')
                        .replace(/\s+/g, '')
                        .replace(/_+$/, '_');
                }
                this.getExamforClass(val);
            }

            if (fieldName == 'exam_id'){
                this.exam_id = val;
                if(val && val > 0){
                    const selectedExam = this.examNameArr.find(exam => exam.id === Number(val));
                    this.examName = selectedExam.text.normalize('NFC')
                        .replace(/[^\p{L}\p{N}\p{M}\s]/gu, '_')
                        .replace(/\s+/g, '')
                        .replace(/_+$/, '');
                }
            }
            const isValid = [this.exam_id, this.class_id, this.academic_year].every(val => Number(val) > 0);

            if (isValid){
                this.disabledTemplateBtn = false;
            } else {
                this.disabledTemplateBtn = true;
            }
        },

        getClass(academic_year) {
            axios.get("class/classList/" + academic_year, {
                params: {
                    campus_id: store.state.user.campus_id
                }
            })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class'
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getExamforClass(class_id) {
            axios.get("exam/examList", {
                params: {
                    class_id: class_id,
                    campus_id: store.state.user.campus_id
                }
            })
            .then(res => {
                if (res.data.length > 0) {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Exam'
                    }];
                    this.examNameArr = $defaultSelectOption.concat(res.data);
                    this.noExamMsg = '';
                    this.isLoading = false;
                } else {
                    this.examNameArr = [];
                    this.noExamMsg = 'No Exam for this class.'
                    this.isLoading = false;
                }
            }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            });
        },

        async confirmRegister() {
            this.submitted = true;
            const isValid = [this.exam_id, this.class_id, this.academic_year].every(val => Number(val) > 0);
            if (this.$v.$invalid || !isValid || this.file_name == '') {
                return;
            }

            const file = this.$refs.fileUploader.files[0];
            if (!file) {
                this.invalidFile = true;
                this.file_name = '';
                return;
            }
            const MAX_FILE_SIZE_MB = 2;
            const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
            if (file.size > MAX_FILE_SIZE_BYTES) {
                this.invalidFileSize = true;
                return;
            } else {
                this.invalidFileSize = false;
            }
            await this.register();
        },

        async register() {
            this.isLoading = true;
            this.disableImportBtn = true;
            let formData = new FormData();
            formData.append("academic_year", this.academic_year);
            formData.append("class_id", this.class_id);
            formData.append("exam_id", this.exam_id);
            formData.append("campus_id", this.$store.state.user.campus_id);
            formData.append("created_id", this.$store.state.user.id);
            formData.append("file", this.$refs.fileUploader.files[0]);
            formData.append("is_auto_grading", this.autoGrading ? 1 : 0);

            axios.post("/grading/import", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                })
                .then(response => {
                    if (response.status == 200) {
                        this.$notification.success("Grading Imported Successfully", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.showList();
                    }
                    else if (response.data.success == false) {
                        this.$notification.error(response.data.message, {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    else {
                        this.$notification.error("something went wrong", {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    this.disableImportBtn = false;
                    this.isLoading = false;
                })
                .catch(error => {
                    if (!error.response) {
                        if (error.message.includes("Network Error")) {
                            this.$notification.error("Something went wrong. Please re-select the file and try again.", {
                                timer: 3,
                                position: "bottomCenter",
                            });
                            this.file_name = '';
                            this.$refs.fileUploader.value = null;
                            this.submitted = false;
                        }
                    } else {
                        this.handleImportValidationError(error);
                    }
                    this.disableImportBtn = false;
                    this.isLoading = false;
                });
            this.submitted = false; 
        },

        showList() {
            this.$router.push({
                path: "/grading/list"
            });
        },

        templateDownload() {
            this.isLoading = true;
            this.disableInputFields = true;
            var request = {
                acd_year_id: this.academic_year,
                class_id: this.class_id,
                exam_id: this.exam_id,
                campus_id: store.state.user.campus_id,
                created_id: store.state.user.id,
                is_auto_grading: this.autoGrading ? 1 : 0,
            };
            axios({
                method: 'get',
                url: 'grading/template-download',
                params: request,
                responseType: 'blob',
            })
            .then(response => {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = this.className + this.examName + '.xlsx';
                link.click();
                this.isLoading = false;
            }).catch(error => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            });
        },

        resetAll() {
            this.submitted = false;
            this.disableInputFields = false;
            this.disabledTemplateBtn = true;
            this.academic_year = '';
            this.exam_id = '';
            this.class_id = '';
            this.changeEvent('', 'academic_year')
            this.$refs.fileUploader.value = null;
            this.file_name = '';
            this.invalidFile = false;
            this.autoGrading = false;
        },

        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                const allowedTypes = ['.xls', '.xlsx'];
                const fileExtension = file.name.split('.').pop().toLowerCase();

                if (!allowedTypes.includes(`.${fileExtension}`)) {
                    this.$notification.error('File type not supported!', {
                        timer: 3,
                        position: 'bottomCenter',
                    });
                    return;
                } else {
                    this.file_name = file.name;
                }
            }
        },

        chooseFile() {
            this.$refs.fileUploader.value = null;
            this.file_name = '';
            this.$refs.fileUploader.click();
            this.submitted = false;
        },

        /**
         * Handle error response from API.
         */
        handleError(error) {
            if (error.response?.status === 401) {
                this.$store.commit('logout');
                window.location.replace('login');
                return;
            }

            const message = error.response?.data?.message || 'Something went wrong.';
            this.$notification.error(message, {
                timer: 3,
                position: 'bottomCenter',
            });
        },

        /**
         * Handle import validation error response from API.
         */
        handleImportValidationError(error) {
            if (error.response?.status === 422) {
                const data = error.response.data || {};
                const errors = data.errors;

                let messages;
                if (Array.isArray(errors?.custom_validation_messages)) {
                    messages = errors.custom_validation_messages;
                } else if (Array.isArray(errors)) {
                    messages = errors;
                } else if (typeof errors === 'object' && errors !== null) {
                    messages = Object.values(errors).flat();
                } else if (data.message) {
                    messages = String(data.message).split('\n').filter(Boolean);
                } else {
                    messages = ['Import validation failed.'];
                }

                window.alert(messages.join('\n'));
                return;
            }

            this.handleError(error);
        },
    },

    mounted() {
        this.isLoading = true;
        this.getCurrentPeriodList();
    },
};
